const angular = require('angular');

const { ProductGroupService } = require('./productgroup.service');
const { productGroupNavComponentDefinition } = require('./productgroup-nav.component');
const { productGroupTileListComponentDefinition } = require('./productgroup-tile-list.component');

angular.module('wowApp.shop')
    .service('ProductGroupService', ProductGroupService)
    .component('wowProductGroup', productGroupNavComponentDefinition)
    .component('wowProductGroupTileList', productGroupTileListComponentDefinition);



// WEBPACK FOOTER //
// ./src/shop/productgroups/index.js